import { Stack, Typography } from "@mui/material";
import moment from "moment";
import { IHostPromotion } from "services/models/Host";
import MailIcon from "@mui/icons-material/Mail";
import { useHostPromotions } from "services/api/SWRService";
import { GridColDef } from "@mui/x-data-grid-pro";
import { dateCol } from "utils/datagrid-utils";
import { GridPaginationProps } from "../helpers";
import { SWRDataGrid } from "../SWRDataGrid";
import Routes from "constants/routes";
import { useNavigate, Outlet } from "react-router-dom";
import { FromLocation } from "../EventsAndPromotions";
import { useMobile } from "hooks/Mobile/useMobile";
import { filterPanelSx } from "..";
import { SMTooltip } from "components/lib/SMTooltip";

type Prop = {
  from: FromLocation;
} & GridPaginationProps;
const columns: GridColDef<IHostPromotion>[] = [
  { field: "inviteOnly", headerName: "Invite Only", type: "boolean", hideable: false },
  {
    field: "name",
    headerName: "Promotion Name",
    flex: 1,
    minWidth: 450,
    renderCell: ({ row }) => (
      <Stack direction="row" spacing={1}>
        {row.inviteOnly && (
          <SMTooltip
            title={
              "This means the promotion is invite only. Invite only means that the promotion is limited by one of the following. A custom list of patrons, only patrons who have link to the mobile app, or only patrons who have not linked to the mobile app."
            }
          >
            <MailIcon />
          </SMTooltip>
        )}
        <Typography>{row.name}</Typography>
      </Stack>
    ),
  },
  { field: "categoryName", headerName: "Category", minWidth: 130 },
  {
    field: "start",
    headerName: "Start Date",
    ...dateCol,
    minWidth: 120,
    valueFormatter: ({ value }) => moment(value).format("MM/DD/YY"),
  },
  {
    field: "end",
    headerName: "End Date",
    ...dateCol,
    minWidth: 120,
    valueFormatter: ({ value }) => moment(value).format("MM/DD/YY"),
  },
  {
    field: "active",
    headerName: "Active",
    minWidth: 140,
    valueGetter: ({ value }) => value ?? "N/A",
    // valueFormatter: ({ value }) => value ?? "N/A",
    type: "singleSelect",
    valueOptions: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "N/A"],
  },
];
export const HostPromotionsTable = ({ from, ...paginationProps }: Prop) => {
  const navigate = useNavigate();
  const response = useHostPromotions();
  const isMobile = useMobile();

  return (
    <>
      <SWRDataGrid
        name="host-player-promotions"
        initialState={{
          columns: {
            columnVisibilityModel: {
              inviteOnly: false,
            },
          },
          sorting: {
            sortModel: [{ field: "start", sort: "asc" }],
          },
        }}
        response={response}
        columns={columns}
        {...paginationProps}
        onRowClick={(item) => {
          const id = item.row.orig_id;
          if (!id) return;
          switch (from) {
            case "dashboard":
              navigate(Routes.forHostDashboardPromotion(id));
              break;
            case "page":
              navigate(Routes.forHostPromotion(id));
              break;
            default:
              console.warn("Unknown from: ", from);
              break;
          }
        }}
        slotProps={{
          filterPanel: isMobile ? filterPanelSx : undefined,
        }}
        noRowsMessage="No Promotions Found"
        clickableRow
      />
      <Outlet />
    </>
  );
};
